// Firebase Analytics 이벤트 상수
export const ANALYTICS_EVENTS = {
  // 페이지 뷰
  PAGE_VIEW: 'page_view',
  // 인증
  LOGIN: 'login',
  SIGN_UP: 'sign_up',
  // 프로젝트
  PROJECT_UPLOAD: 'project_upload',
  PROJECT_DOWNLOAD: 'project_download',
  PROJECT_VIEW: 'project_view',
  // 구독
  TRIAL_START: 'trial_start',
  PLAN_REQUEST: 'plan_request',
  // 일반
  BUTTON_CLICK: 'button_click',
} as const;

export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS];

// 이벤트 파라미터 타입 정의
export interface PageViewParams {
  page_title: string;
  page_location: string;
  page_path: string;
}

export interface EventParams {
  [key: string]: string | number | boolean | undefined;
}
